module.exports = __webpack_public_path__ + "a06fe4437330c12495b04d8fa00d1e79.svg"